module.exports = __webpack_public_path__ + "img/btn.cfd1467c.png";